import { render, staticRenderFns } from "./AudioFileEventViewer.vue?vue&type=template&id=565ce6f4"
import script from "./AudioFileEventViewer.vue?vue&type=script&lang=js"
export * from "./AudioFileEventViewer.vue?vue&type=script&lang=js"
import style0 from "./AudioFileEventViewer.vue?vue&type=style&index=0&id=565ce6f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports